/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import Feed from './Feed';

class FeedWrapper extends Component {
  render() {
    const { username } = this.props;
    return (
      <div className="feed-wrapper">
        <header className="feed-header">
          <div className="feed-header-wrapper">
            <div className="header-left">
              <img
                src="https://www.instagram.com/static/images/web/mobile_nav_type_logo.png/735145cfe0a4.png"
                alt="instagram logo"
              />
            </div>
            <div className="header-center">
              <input placeholder="Search" type="text" />
            </div>
            <div className="header-right">
              <div className="header-right-nav">
                <a className="home-nav" href="#">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width={24}
                    height={24}
                    viewBox="0 0 48 48"
                    style={{ fill: '#000000' }}
                  >
                    <path d="M39.5,43h-9c-1.381,0-2.5-1.119-2.5-2.5v-9c0-1.105-0.895-2-2-2h-4c-1.105,0-2,0.895-2,2v9c0,1.381-1.119,2.5-2.5,2.5h-9	C7.119,43,6,41.881,6,40.5V21.413c0-2.299,1.054-4.471,2.859-5.893L23.071,4.321c0.545-0.428,1.313-0.428,1.857,0L39.142,15.52	C40.947,16.942,42,19.113,42,21.411V40.5C42,41.881,40.881,43,39.5,43z" />
                  </svg>
                </a>
                <a className="share-nav" href="#">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width={24}
                    height={24}
                    viewBox="0 0 16 16"
                    fill="#000000"
                  >
                    <path
                      fill="white"
                      d="M0.912 5.919L15.174 0.826 10.081 15.088z"
                    />
                    <path
                      fill="black"
                      d="M14.348,1.652L9.875,14.176L1.824,6.125L14.348,1.652 M16,0L0,5.714L10.286,16L16,0L16,0z"
                    />
                    <g>
                      <path
                        fill="white"
                        d="M4.5 11.5L4.5 9.268 11.197 4.803 6.732 11.5z"
                      />
                      <path
                        fill="black"
                        d="M9.394,6.606L6.465,11H5V9.535L9.394,6.606 M13,3L4,9v3h3L13,3L13,3z"
                      />
                    </g>
                  </svg>
                </a>
                <a className="explore-nav" href="#">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    style={{ fill: '#000000' }}
                  >
                    <path d="M 12 0 C 5.398438 0 0 5.398438 0 12 C 0 18.601563 5.398438 24 12 24 C 18.601563 24 24 18.601563 24 12 C 24 5.398438 18.601563 0 12 0 Z M 12 2 C 17.5 2 22 6.5 22 12 C 22 17.5 17.5 22 12 22 C 6.5 22 2 17.5 2 12 C 2 6.5 6.5 2 12 2 Z M 18 6 L 10.09375 10.09375 L 6 18 L 13.90625 13.90625 Z M 12 10.90625 C 12.601563 10.90625 13.09375 11.398438 13.09375 12 C 13.09375 12.601563 12.601563 13.09375 12 13.09375 C 11.398438 13.09375 10.90625 12.601563 10.90625 12 C 10.90625 11.398438 11.398438 10.90625 12 10.90625 Z" />
                  </svg>
                </a>
                <a className="follow-nav" href="#">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width={24}
                    height={24}
                    viewBox="0 0 48 48"
                    fill="white"
                    stroke="black"
                    strokeWidth="5%"
                  >
                    <path d="M 15 7 C 8.9424416 7 4 11.942442 4 18 C 4 22.096154 7.0876448 25.952899 10.851562 29.908203 C 14.615481 33.863507 19.248379 37.869472 22.939453 41.560547 A 1.50015 1.50015 0 0 0 25.060547 41.560547 C 28.751621 37.869472 33.384518 33.863507 37.148438 29.908203 C 40.912356 25.952899 44 22.096154 44 18 C 44 11.942442 39.057558 7 33 7 C 29.523564 7 26.496821 8.8664883 24 12.037109 C 21.503179 8.8664883 18.476436 7 15 7 z" />
                  </svg>
                </a>
              </div>
              <div className="profile-nav-container">
                <a className="profile-nav" href="#">
                  <img
                    src="https://randomuser.me/api/portraits/thumb/men/81.jpg"
                    alt="user"
                  />
                </a>
              </div>
            </div>
          </div>
        </header>
        <div className="main-container">
          <div className="feed">
            <Feed username={username} />
          </div>
          <div className="sidebar-wrapper">
            <div className="sidebar">
              <header className="user-info">
                <div className="user-image">
                  <a href="#">
                    <img
                      src="https://randomuser.me/api/portraits/thumb/men/81.jpg"
                      alt="user"
                    />
                  </a>
                </div>
                <div className="user-name">
                  <p>
                    <a href="#">dsymiller</a>
                  </p>
                  <p>Derek Miller</p>
                </div>
              </header>
              <table className="follow-suggestions">
                <thead>
                  <tr>
                    <th className="cell-left">Suggestions For You</th>
                    <th className="cell-right">
                      <a href="#">See All</a>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="cell-left">
                      <div className="follow-info">
                        <div className="follow-image">
                          <a href="#">
                            <img
                              src="https://randomuser.me/api/portraits/thumb/women/10.jpg"
                              alt="user"
                            />
                          </a>
                        </div>
                        <div className="follow-name">
                          <p>
                            <a href="#">redwolf102</a>
                          </p>
                          <p>Suggested for you</p>
                        </div>
                      </div>
                    </td>
                    <td className="cell-right">
                      <button>Follow</button>
                    </td>
                  </tr>
                  <tr>
                    <td className="cell-left">
                      <div className="follow-info">
                        <div className="follow-image">
                          <a href="#">
                            <img
                              src="https://randomuser.me/api/portraits/thumb/men/80.jpg"
                              alt="user"
                            />
                          </a>
                        </div>
                        <div className="follow-name">
                          <p>
                            <a href="#">ticklishpeacock424</a>
                          </p>
                          <p>Suggested for you</p>
                        </div>
                      </div>
                    </td>
                    <td className="cell-right">
                      <button>Follow</button>
                    </td>
                  </tr>
                  <tr>
                    <td className="cell-left">
                      <div className="follow-info">
                        <div className="follow-image">
                          <a href="#">
                            <img
                              src="https://randomuser.me/api/portraits/thumb/women/8.jpg"
                              alt="user"
                            />
                          </a>
                        </div>
                        <div className="follow-name">
                          <p>
                            <a href="#">lazyfish942</a>
                          </p>
                          <p>Suggested for you</p>
                        </div>
                      </div>
                    </td>
                    <td className="cell-right">
                      <button>Follow</button>
                    </td>
                  </tr>
                  <tr>
                    <td className="cell-left">
                      <div className="follow-info">
                        <div className="follow-image">
                          <a href="#">
                            <img
                              src="https://randomuser.me/api/portraits/thumb/women/6.jpg"
                              alt="user"
                            />
                          </a>
                        </div>
                        <div className="follow-name">
                          <p>
                            <a href="#">orangefrog580</a>
                          </p>
                          <p>Suggested for you</p>
                        </div>
                      </div>
                    </td>
                    <td className="cell-right">
                      <button>Follow</button>
                    </td>
                  </tr>
                  <tr>
                    <td className="cell-left">
                      <div className="follow-info">
                        <div className="follow-image">
                          <a href="#">
                            <img
                              src="https://randomuser.me/api/portraits/thumb/men/10.jpg"
                              alt="user"
                            />
                          </a>
                        </div>
                        <div className="follow-name">
                          <p>
                            <a href="#">purpleleopard568</a>
                          </p>
                          <p>Suggested for you</p>
                        </div>
                      </div>
                    </td>
                    <td className="cell-right">
                      <button>Follow</button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <footer className="sidebar-footer">
                <p>
                  <a href="#">About</a> ·<a href="#">Help</a> ·
                  <a href="#">Press</a> ·<a href="#">API</a> ·
                  <a href="#">Jobs</a> ·<a href="#">Privacy</a> ·
                  <a href="#">Terms</a> ·
                </p>
                <p>
                  <a href="#">Locations</a> ·<a href="#">Top Accounts</a> ·
                  <a href="#">Hashtags</a> ·<a href="#">Language</a>
                </p>
                <p className="copyright">© 2020 INSTAGRAM FROM FACEBOOK</p>
              </footer>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default FeedWrapper;
